document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.mobile-toggle');
  if (toggle) {
    document.body.classList.toggle('menu-open');
    const nav = document.querySelector('.header__nav');
    if (nav) nav.style.display = document.body.classList.contains('menu-open') ? 'flex' : '';
  }
});